import { Container, Row, Col, Button } from "react-bootstrap";
import ImageMessageBox from "../Images/ImageMessageBox.png"

function Home() {   
    return (        
        <Container fluid style={{backgroundColor: "#f4f6f7"}}>
            <Row style={{padding: "1.5%", fontSize: "2.5vw", color: "#626567"}}>
                <Col>
                    <div>
                        <br/>
                        <p>
                            Willkommen auf unserer Seite,<br />
                            Schön, dass Sie uns gefunden haben.
                        </p>
                    </div>
                </Col>
            </Row>

            <Row style={{margin: "5%"}}>                
                <Col style={{padding: "5%", backgroundColor: "#7ea4a5"}}>
                    <img src={ImageMessageBox} alt="MessageBox" className="img-fluid"></img>                    
                </Col>                
                <Col style={{padding: "5%", backgroundColor: "#7ea4a5", textAlign: "Center"}}>
                    <p style={{color: "white", fontSize: "3vw"}}>MessageBox</p>
                    <p style={{color: "#626567", fontSize: "2vw"}}> Die Nachrichten-Box für alle alleinlebenden Seniorinnen und Senioren</p>
                    <br/>
                    <p>
                        <Button variant="primary" size="lg" href="/messagebox" style={{backgroundColor: "#6083bf", borderColor: "#6083bf"}}>mehr erfahren</Button>
                    </p>                    
                </Col>
            </Row>      
            <Row>
            </Row>  
        </Container>
    )
}

export default Home;